import PropTypes from 'prop-types';
import {PAGE_DEFAULT_PAGE} from '../../../services/ApiService/apiConstants';



// ------ filter
export const LIST_FILTER_TYPE_CONTAINS = 'c';
export const LIST_FILTER_TYPE_EQUALS = 'e';


// ------ sort
export const SORT_DIR_ASC = 'asc';
export const SORT_DIR_DESC = 'desc';


// ------ page sizes
export const PAGE_SIZE_10 = 10;
export const PAGE_SIZE_20 = 20;
export const PAGE_SIZE_50 = 50;
export const PAGE_SIZE_100 = 100;

export const PAGE_SIZE_DEFAULT = PAGE_SIZE_10;

export const PAGE_SIZES = [
    PAGE_SIZE_10,
    PAGE_SIZE_20,
    PAGE_SIZE_50,
    PAGE_SIZE_100
];


// ------ request
export const LIST_REQUEST_DEFAULT = {
    filter: [],
    page: PAGE_DEFAULT_PAGE,
    pageSize: PAGE_SIZE_DEFAULT,
    sortBy: []
};


// ------ shape
export const SHAPE_LIST_ROOT = {
    currentElements: PropTypes.number.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    isFirst: PropTypes.bool.isRequired,
    isLast: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    noFilterTotalElements: PropTypes.number,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalElements: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired
};
